<template>
  <div class="addShop">
    <div class="addShop_content">
      <div class="addShop_shop">
        <img
          :src="addShopContent.shop_pic"
          alt=""
          style="width: 0.88rem; height: 0.88rem; margin-right: 0.15rem"
        />
        <p
          style="
            font-size: 0.14rem;
            font-weight: bold;
            color: #333333;
            line-height: 0.2rem;
            height: 0.2rem;
            width: 2.1rem;
          "
        >
          {{ addShopContent.shop_title }}
        </p>
      </div>
      <div class="addShop_price">
        <van-cell-group>
          <van-field
            label="进货价格"
            :value="'￥' + addShopContent.shop_price + '/盒'"
            readonly
            class="onePrice"
          />
          <van-field
            required
            v-model="Addnumber"
            label="补货数量"
            placeholder="请填写补货数量"
          />
        </van-cell-group>
      </div>
      <div class="pay_method">
        <van-field label="请选择支付方式" readonly required />
        <div class="line"></div>
        <van-radio-group v-model="radio" icon-size=".12rem">
          <van-cell-group>
            <van-cell
              title="微信支付"
              clickable
              @click="radio = '1'"
              :icon="require('../../assets/img/pay/icon_weixin@2x.png')"
            >
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </div>

    <div class="bottom">
      <van-button round type="info" class="MakeSureAdd" @click="toMakeSure()"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
// import { addressList, getMakeSureOrder, scoreBuy } from "@/api/home.js";

import { getAddShopOrder, doPay, toWeiLogin, weixinBind } from "../../api/home";
export default {
  data() {
    return {
      Addnumber: "",
      radio: "1",
      addShopContent: {},
      orderid: "",
    };
  },
  created() {
    if (this.$route.params.val) {
      this.addShopContent = this.$route.params.val;
      sessionStorage.setItem(
        "addshopVal",
        JSON.stringify(this.$route.params.val)
      );
    } else {
      this.addShopContent = JSON.parse(sessionStorage.getItem("addshopVal"));
    }
    if (window.location.href.split("code=")[1]) {
      const href = this.showWindowHref();
      this.code = href.code;
      this.weixin();
    }
  },
  beforeDestroy(){
    sessionStorage.removeItem('addshopVal')
  },
  methods: {
    toMakeSure() {
      // console.log(this.Addnumber)
      // 下单得到订单号
      // 判断输入的是不是纯数字
      var regex = /^[0-9]+$/;
      if (!regex.test(this.Addnumber)) {
        Toast("请正确输入");
      } else if (this.Addnumber == 0) {
        Toast("补货数量至少1件");
      } else {
        getAddShopOrder({ num: this.Addnumber })
          .then((res) => {
            this.orderid = res.data.backdata.orderid;
            // console.log(this.orderid);
          })
          .catch((err) => {
            console.log(err);
          });
        this.toPay();
      }
    },
    // 微信绑定
    weixin() {
      weixinBind({
        code: this.code,
      }).then((res) => {
        if (res.data.msg == "微信未绑定") {
          sessionStorage.setItem("openid", res.data.backdata.openid);
          Toast("登陆后绑定手机号");
          this.$router.push("/login");
        } else {
          localStorage.setItem("userToken", res.data.backdata.token);
        }
      });
    },
    // 获取url query 拼接 参数
    showWindowHref() {
      var sHref = window.location.href;
      var args = sHref.split("?");
      if (args[0] == sHref) {
        return "";
      }
      var arr = args[1].split("&");
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        var arg = arr[i].split("=");
        obj[arg[0]] = arg[1];
      }
      return obj;
    },
    // 微信登录
    toWeiXi() {
      const url = window.location.href; // 获取当前的地址（支付订单的链接）
      toWeiLogin({
        backurl: url, // 后来再返回支付订单
      })
        .then((res) => {
          if (res.data.code == 0) {
            window.location.href = res.data.backdata.loginurl; // 微信登录链接
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发起支付
    toPay() {
      doPay({
        orderid: this.orderid,
        paycode: "wxmp",
      }).then((res) => {
        if (res.data.code == 0) {
          this.PayParameters = JSON.parse(res.data.backdata.PayParameters);
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady();
          }
        } else {
          // 只进行了手机号登录，微信未登录
          if (res.data.code == 402) {
            this.$dialog
              .confirm({
                message: "请先微信授权登录",
              })
              .then(() => {
                this.toWeiXi(); // 进行微信登录并绑定
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      });
    },
    // 微信支付后的回调链接
    onBridgeReady() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        this.PayParameters,
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.back();
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
  },
};
</script>

<style lang='scss'>
.addShop {
  padding: 0.49rem 0 0.22rem 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .addShop_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .addShop_shop {
      width: 100%;
      height: 1.1rem;
      background: #ffffff;
      padding: 0.11rem 0.15rem;
      display: flex;
    }
    // 进货价格
    .addShop_price {
      width: 3.45rem;
      height: 0.89rem;
      margin-top: 0.11rem;
      background: #ffffff;
      border-radius: 0.08rem;
      .van-cell--required::before {
        margin-left: 0.13rem;
        left: 0.03rem;
        font-size: 0.14rem;
      }
      .van-field__control {
        font-size: 0.14rem;
      }
      .onePrice {
        .van-field__control {
          color: #93683d;
        }
      }

      .van-field__label {
        margin-left: 0.17rem;
        color: #333333;
        font-size: 0.14rem;
      }
    }
    // 支付方式
    .pay_method {
      margin-top: 0.11rem;
      width: 3.45rem;
      height: 1rem;
      background: #ffffff;
      border-radius: 0.08rem;
      padding: 0 0.15rem;

      .van-field__label {
        width: 1rem;
        margin-left: 0.17rem;
      }
      .van-cell__title {
        height: 0.41rem;
        font-size: 0.12rem;
        color: #999a9c;
        line-height: 0.41rem;
      }
      .van-cell--required::before {
        left: 0.02rem;
        font-size: 0.14rem;
      }
      .line {
        width: 3.15rem;
        height: 0.01rem;
        background: #f3f1f4;
      }
      // 支付宝微信图标
      .van-cell__left-icon {
        height: auto;
        margin-right: 0.08rem;
        .van-icon__image {
          width: 0.24rem;
          height: 0.24rem;
        }
      }
      .van-cell::after {
        border: none;
      }
      [class*="van-hairline"]::after {
        border: none;
      }
      .van-cell {
        padding: 0;
        display: flex;
        align-items: center;
        font-size: 0.14rem;
      }
      .van-radio__icon {
        border: none;
        background: none;
        .van-icon {
          border: none;
          background: none;

          .van-icon::before {
            display: inline-block;
            height: 0.12rem;
            width: 0.12rem;
          }
        }

        .van-icon-success::before {
          display: none;
        }
      }
      .van-radio__icon--checked {
        background: url("../../assets/img/pay/icon_select@2x.png") no-repeat;
        width: 0.12rem;
        height: 0.12rem;
        background-size: contain;
      }
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .MakeSureAdd {
      border: none;
      width: 2.72rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      border-radius: 0.22rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
  }
}
</style>
